export const orderCancellation = {
  'order-cancellation.modal.heading': 'Cancel your order?',
  'order-cancellation.modal.body':
    "As long as your order hasn't been made, we’re able to refund and cancel your order.\n\nAt this time, we are not able to reissue rewards applied to canceled orders. Do you want to proceed with the cancelation?",
  'order-cancellation.modal.cta.go-back': 'Go back',
  'order-cancellation.modal.cta.cancel-order': 'Cancel order',
  'order-cancellation.modal.a11y-label': 'Order cancelation modal',

  // ─── Banners ─────────────────────────────────────────────────────────

  'order-cancellation.success':
    'Your order has been successfully cancelled. Your refund will post back to your card within 3-5 business days.',
  'order-cancellation.error.generic':
    'We were unable to cancel your order. Please try again.',
  'order-cancellation.error.refund-failed':
    'Your order has been successfully cancelled, but your refund did not process correctly. Please reach out to our customer support team to issue a refund to your account.',
  'order-cancellation.error.max-limit-exceed':
    'We were unable to cancel your order. Please reach out to customer support.',
  'order-cancellation.error.preparing':
    'We\'re sorry, we\'re unable to cancel your order as our team is already preparing it. Our support team can be reached at "Contact Us" in the Account menu.',
  'order-cancellation.error.special':
    'We were unable to cancel your order. Please reach out to customer support.',
};
